import { useContext } from "react";
import FlowControllerContext from "./FlowControllerContext";

var useFlowContext = function useFlowContext() {
  return useContext(FlowControllerContext);
};

export default useFlowContext;